// extracted by mini-css-extract-plugin
export var sbShowMain = "table-module--sb-show-main--1CygK";
export var table = "table-module--table--b2wOA";
export var mobileTable = "table-module--mobileTable--KNXPK";
export var item = "table-module--item--5rKQ5";
export var itemRow = "table-module--itemRow--2bIIv";